'use client'

import Link from "next/link"
import AppIcon from "@/app/components/atomic/AppIcon"
import { PREVOYANCE_PRODUCTS } from "@/app/components/pageModels/prevoyanceLanding/prevoyanceProducts"
import { ProvidentTrackingEvents } from "@/app/constants/providentTracking"
import { useTracking } from "@/app/contexts/tracking-context"

export default function PrevoyanceProductPicker() {
    const { track } = useTracking()

    return (
        <div
            className="flex flex-col gap-[18px] rounded-3xl bg-white p-5 shadow-[0_1px_2px_-1px_rgba(0,0,0,0.1),0_1px_3px_0_rgba(0,0,0,0.1),0_1px_4px_0_rgba(0,0,0,0.25)] md:p-7"
            data-test="prevoyance-product-picker"
        >
            <div className="flex flex-col gap-1.5">
                <div className="flex items-center justify-between gap-3">
                    <h2 className="block px-0 text-[22px] leading-tight md:text-2xl">Quelle protection recherchez-vous&nbsp;?</h2>
                    <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-pastel-yellow px-3 py-1 text-[13px] font-bold text-pale">
                        <AppIcon iconClassName="fa-clock" type="regular" size="sm" />2 min
                    </span>
                </div>
                <p className="m-0 text-sm text-[#71717A]">Sélectionnez un produit pour démarrer votre devis.</p>
            </div>

            <ul className="m-0 flex list-none flex-col gap-2 p-0">
                {PREVOYANCE_PRODUCTS.map((product) => (
                    <li key={product.key}>
                        <Link
                            href={product.url}
                            onClick={() => track({ event: ProvidentTrackingEvents.funnelAccess(product.key) })}
                            data-test={`prevoyance-product-${product.key}`}
                            className="group flex items-center gap-3 rounded-2xl border-2 border-[#EFE6E2] bg-white px-3 py-2.5 text-left no-underline transition-colors hover:border-rm-blue hover:bg-rm-blue/10 focus:outline-none focus-visible:border-rm-blue focus-visible:bg-rm-blue/10 md:px-3.5"
                        >
                            <span className="flex size-[34px] shrink-0 items-center justify-center rounded-[10px] bg-neutral transition-colors group-hover:bg-white group-focus-visible:bg-white md:size-[38px]">
                                <AppIcon iconClassName={product.icon} size="md" className="text-pale" />
                            </span>
                            <span className="flex min-w-0 flex-1 flex-col gap-px">
                                <span className="text-[15px] font-bold leading-snug text-pale">{product.name}</span>
                                <span className="text-[13px] leading-snug text-[#71717A]">{product.tagline}</span>
                            </span>
                            <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-neutral text-pale transition-colors group-hover:bg-rm-orange group-hover:text-white group-focus-visible:bg-rm-orange group-focus-visible:text-white">
                                <AppIcon iconClassName="fa-arrow-right" size="sm" />
                            </span>
                        </Link>
                    </li>
                ))}
            </ul>

            <p className="m-0 text-center text-[13px] leading-snug text-[#71717A]">
                <i className="fa-regular fa-lock mr-2" aria-hidden />
                Gratuit, sans engagement, résultats en 2 minutes
            </p>
        </div>
    )
}
